import React from "react";

export const SurveyRadiogroupIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props} // Spread any additional props
  >
    <path
      d="M7.93667 10.1931L6.42199 8.6784C6.26766 8.52296 6.07827 8.44524 5.85381 8.44524C5.62933 8.44524 5.43274 8.5296 5.26403 8.69831C5.10938 8.85297 5.03205 9.04776 5.03205 9.28267C5.03205 9.5176 5.10976 9.71278 5.26519 9.8682L7.33991 11.9429C7.49834 12.1014 7.69726 12.1806 7.93667 12.1806C8.17607 12.1806 8.37498 12.1014 8.53341 11.9429L12.7224 7.74945C12.8778 7.59403 12.9556 7.40489 12.9556 7.18206C12.9556 6.95923 12.8716 6.76426 12.7036 6.59715C12.5482 6.44171 12.353 6.36399 12.1181 6.36399C11.8832 6.36399 11.688 6.44171 11.5326 6.59715L7.93667 10.1931ZM9.00011 16.6525C7.9387 16.6525 6.94279 16.4517 6.01239 16.0502C5.08199 15.6488 4.27268 15.1039 3.58444 14.4157C2.8962 13.7274 2.35134 12.9181 1.94987 11.9877C1.54839 11.0573 1.34766 10.0614 1.34766 9C1.34766 7.93859 1.54839 6.94268 1.94987 6.01228C2.35134 5.08188 2.8962 4.27256 3.58444 3.58433C4.27268 2.89609 5.08199 2.35123 6.01239 1.94976C6.94279 1.54828 7.9387 1.34754 9.00011 1.34754C10.0615 1.34754 11.0574 1.54828 11.9878 1.94976C12.9182 2.35123 13.7276 2.89609 14.4158 3.58433C15.104 4.27256 15.6489 5.08188 16.0504 6.01228C16.4518 6.94268 16.6526 7.93859 16.6526 9C16.6526 10.0614 16.4518 11.0573 16.0504 11.9877C15.6489 12.9181 15.104 13.7274 14.4158 14.4157C13.7276 15.1039 12.9182 15.6488 11.9878 16.0502C11.0574 16.4517 10.0615 16.6525 9.00011 16.6525Z"
      fill="#767676"
    />
  </svg>
);
